import type { Ref } from "@sitescene/types";

import { getRefId } from "../location/installation-ids";

type ExternalIdItem = {
	external?: null | { id?: string };
	installation?: null | Ref<{ id: string }>;
};

/**
 * True when an item already uses this external id for the given installation
 * (matches the Mongo unique index on installation + external.id).
 * Comparison is case-insensitive. Mirrors dashboard locations util.
 */
export const hasDuplicateExternalId = (
	externalId: string,
	installationId: string | undefined,
	items: ExternalIdItem[],
): boolean => {
	const normalized = externalId.trim().toLowerCase();
	if (!normalized || !installationId) return false;

	return items.some((item) => {
		const itemInstallationId = getRefId(item.installation);
		const itemExternalId = item.external?.id?.trim().toLowerCase();
		return (
			itemExternalId === normalized && itemInstallationId === installationId
		);
	});
};
